import ApiService from '@core/services/ApiService';

export interface WalkthroughProgress {
  id?: string;
  developerId?: string;
  walkthroughId: string;
  currentStep: number;
  status: 'in_progress' | 'completed' | 'seen_intro' | 'skipped';
  updatedAt?: string;
}

class WalkthroughService {
  private get api() {
    return ApiService.getDefaultApiInstance();
  }

  async getProgress(
    walkthroughId: string,
  ): Promise<WalkthroughProgress | null> {
    try {
      const response = await this.api.get<WalkthroughProgress>(
        `/api/walkthrough-progress/${walkthroughId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async getAllProgress(): Promise<WalkthroughProgress[]> {
    const response = await this.api.get<WalkthroughProgress[]>(
      '/api/walkthrough-progress',
    );
    return response.data;
  }

  async saveProgress(
    progress: Omit<WalkthroughProgress, 'id' | 'developerId'>,
  ): Promise<WalkthroughProgress> {
    const response = await this.api.post<WalkthroughProgress>(
      '/api/walkthrough-progress',
      progress,
    );
    return response.data;
  }

  async updateProgress(
    walkthroughId: string,
    progress: Partial<WalkthroughProgress>,
  ): Promise<void> {
    await this.api.patch(
      `/api/walkthrough-progress/${walkthroughId}`,
      progress,
    );
  }
}

export default new WalkthroughService();
